<template>
  <div>
    <div class="ft-16 font-bold mb15">Target</div>
    <div class="font-500 mb24"><span class="icon-ico-date yellow ft-16"></span> {{ moment().format('MMMM YYYY') }}</div>
    <div id="dash" class="row">
      <div class="col-sm-4 col-xl-3">
        <div class="target-box-item mb30 p20">
          <div class="d-flex">
            <div><img src="@/assets/img/icon-target.png" class="img-fluid"></div>
            <div class="ml15">
              <div class="head-target mb5">{{ target?.total_target }}<span>ton</span></div>
              <span>Total Target</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-4 col-xl-3">
        <div class="target-box-item mb30 p20">
          <div class="d-flex">
            <div><img src="@/assets/img/icon-target-2.png" class="img-fluid"></div>
            <div class="ml15">
              <div class="head-target mb5">{{ target?.total_sales }}<span>ton</span></div>
              <span>Total Sales</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-4 col-xl-3">
        <div class="target-box-item mb30 p20">
          <div class="d-flex">
            <div><img src="@/assets/img/icon-target-3.png" class="img-fluid"></div>
            <div class="ml15">
              <div class="head-target mb5">{{ target?.remaining_target }}<span>ton</span></div>
              <span>Remaining Target</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: "DashboardTarget",
  props: ['target'],
  data() {
    return {
      moment
    }
  }
}
</script>
